import type MailListFocusInfo from '../store/schema/MailListFocusInfo';
import type TableView from '../store/schema/TableView';
import { mutatorAction } from 'satcheljs';

// Mutator action to set focus info for a given table view
export default mutatorAction(
    'setMailListFocusInfo',
    function setMailListFocusInfo(tableView: TableView, newFocusInfo: MailListFocusInfo) {
        if (!tableView) {
            return;
        }
        const oldFocusInfo = tableView.focusInfo;
        let shouldFocusInMailList = oldFocusInfo.shouldFocusInMailList;
        if (newFocusInfo.shouldFocusInMailList !== undefined) {
            shouldFocusInMailList = !!newFocusInfo.shouldFocusInMailList;
        }
        let focusedRowId = oldFocusInfo.focusedRowId;
        if (newFocusInfo.focusedRowId !== undefined) {
            focusedRowId = newFocusInfo.focusedRowId;
        }
        tableView.focusInfo = { shouldFocusInMailList, focusedRowId };
    }
);
